<script>
import { h, computed, toRefs, withDirectives } from 'vue';

import { bsTooltip } from 'JIX/vue-bs-tooltip.js';
import { highlight as highlightDirective } from 'JIX/vue-highlight.js';
import i18n from './SentenceList.i18n.js';

const highlightMarkerRe = /\[\[==|==\]\]/g;

function isLast(list, index) {
    return index === list.length - 1;
}

function splitList(items, maxShown) {
    const split = { prefix: [], last: [] };

    const n = items.length;
    if (n > 1) {
        if (maxShown !== undefined && n > maxShown) {
            split.prefix = items.slice(0, maxShown - 1);
            split.last = items.slice(maxShown - 1);
        } else {
            split.prefix = items.slice(0, n - 1);
            split.last = items.slice(-1);
        }
        if (split.last.length > 1) {
            split.last = split.last.map(s => s.replace(highlightMarkerRe, ''));
        }
    } else {
        split.prefix = items;
    }

    return split;
}

function* prefixChildren(items, highlight) {
    if (highlight) {
        for (let i = 0; i < items.length; i++) {
            const span = h('span');
            yield withDirectives(span, [ [highlightDirective, items[i]] ]);
            if (!isLast(items, i)) {
                yield ', ';
            }
        }
    } else {
        yield items.join(', ');
    }
}

function* lastChildren(items, highlight) {
    if (items.length > 1) {
        yield " " + i18n.and() + " ";
        let last = items;
        if (highlight) {
            last = last.map(s => s.replace(highlightMarkerRe, ''));
        }

        const span = h('span', {
            class: "list-sentence-shortned",
            key: 'tooltip',
        }, i18n.countOthers(last.length));
        yield withDirectives(span, [ [bsTooltip, last.join(', ')] ]);
    } else if (items.length === 1) {
        yield " " + i18n.and() + " ";
        if (highlight) {
            const span = h('span', { key: 'last' });
            yield withDirectives(span, [ [highlightDirective, items[0]] ]);
        } else {
            yield items[0];
        }
    }
}

function* concatIters(...args) {
    for (const iter of args) {
        for (const x of iter) {
            yield x;
        }
    }
}

export default {
    props: {
        items: {
            type: Array,
            required: true,
        },
        maxShown: {
            type: Number,
            default: undefined,
        },
        highlight: {
            type: Boolean,
            default: false,
        }
    },
    setup(props) {
        const { items, maxShown, highlight } = toRefs(props);

        const children = computed(() => {
            const { prefix, last } = splitList(items.value, maxShown.value);
            return Array.from(concatIters(
                prefixChildren(prefix, highlight.value),
                lastChildren(last, highlight.value),
            ));
        });

        return () => h('span', {}, children.value);
    },
};
</script>
